import { render, staticRenderFns } from "./PrintButton.vue?vue&type=template&id=71da4043"
import script from "./PrintButton.vue?vue&type=script&lang=ts"
export * from "./PrintButton.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/tmp/build_bef45e0e/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('71da4043')) {
      api.createRecord('71da4043', component.options)
    } else {
      api.reload('71da4043', component.options)
    }
    module.hot.accept("./PrintButton.vue?vue&type=template&id=71da4043", function () {
      api.rerender('71da4043', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/global/PrintButton.vue"
export default component.exports